import styled from 'styled-components'
import ReactLoading from 'react-loading'

const StyledDiv = styled.div`
  fill: #1b3a49;
  height: 100%;
  width: 100%;
  position: fixed;
`

const CenteredDiv = styled.div`
  position: relative;
  margin: 0 auto;
  width: 50%;
  top: 35%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const StyledReactLoading = styled(ReactLoading)``

export const CenteredLoadingContainer = ({
  topComponent,
  bottomComponent,
  color = '#1b3a49',
}) => {
  return (
    <StyledDiv>
      <CenteredDiv>
        {topComponent && topComponent}
        <StyledReactLoading type={'bars'} color={color} />
        {bottomComponent && bottomComponent}
      </CenteredDiv>
    </StyledDiv>
  )
}
